{
	"closePosition": {
		"title": "Закрытие позиции",
		"positionSize": "Объем позиции",
		"ticker": "Тикер",
		"price": "Цена",
		"profitabilityInDollar": "Доходность в $",
		"totalPcs": "Всего, шт.",
		"position": "Позиция",
		"averagePrice": "Средняя цена",
		"profitabilityInPercent": "Доходность в %",
		"availablePcs": "Доступно, шт.",
		"orderType": "Тип ордера",
		"orderDuration": "Срок ордера",
		"cancelOpenedOrders": "Отменить открытые ордера",
		"cancel": "Отмена",
		"qty": "Шт.",
		"qtySlider": "{{qty}} шт.",
		"confirmButton": "Закрыть позицию"
	}
}
